<script lang="ts" module>
	import { createContext, getContext, hasContext, onMount, setContext } from "svelte";

	// switching to the https://github.com/sveltejs/svelte/pull/18558 branch removed has.. from createContext it looks like
	const CKEY = Symbol("current route group");
	const getCurrentRouteGroup = () => getContext(CKEY) as GroupContext;
	const setCurrentRouteGroup = (value: GroupContext) => setContext(CKEY, value);
	const hasCurrentRouteGroup = () => hasContext(CKEY);

	const [internalGetFailedSnippet, setFailedSnippet] =
		createContext<Snippet<[error: unknown, reset: () => void]>>();

	export { getCurrentRouteGroup, internalGetFailedSnippet };
</script>

<script lang="ts">
	import { type Snippet } from "svelte";

	import { GroupContext, route } from "./lib.svelte.ts";

	interface Props {
		children: Snippet;
		notFound: Snippet;
		failed?: Snippet<[error: unknown, reset: () => void]>;
	}

	const { children, notFound, failed }: Props = $props();

	const ctx = new GroupContext();
	const parent = hasCurrentRouteGroup() ? getCurrentRouteGroup() : route.ctx;
	setCurrentRouteGroup(ctx);

	// svelte-ignore state_referenced_locally
	if (failed) {
		setFailedSnippet(failed);
	}

	if (parent) {
		parent.internalNest(ctx);
		$effect(() => () => parent.internalUnnest(ctx));
	} else {
		route.ctx = ctx;
	}

	let init = $state(false);
	onMount(() => {
		ctx.internalRoute(route.url);
		init = true;
	});
</script>

{@render children()}

{#if init && ctx.pattern == undefined}
	{@render notFound()}
{/if}
